import { Component, Input, OnInit } from '@angular/core';
import { MenuCategory, MenuSection } from 'src/shared/models/menu.model';

@Component({
    selector: 'organism-menu-list',
    templateUrl: './menu-list.component.html',
    styleUrls: ['./menu-list.component.scss'],
})
export class MenuListComponent implements OnInit  {
  @Input() menuList: MenuSection[] = [];
  activeSectionIndex: number | null = null;

  ngOnInit(): void {}

  toggleMenu(index: number) {
    this.activeSectionIndex = index;
  }

  isVisible(section: MenuCategory[] | undefined):boolean | null {
    if(!section) return null;
    return section.some((category) => category.items.length > 0)
  }

 }
